import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { COREUI_CARD_IMPORTS, COREUI_LAYOUT_IMPORTS } from '@utils/coreui';

@Component({
  selector: 'app-auth-base-layout',
  imports: [
    CommonModule,
    ...COREUI_LAYOUT_IMPORTS,
    ...COREUI_CARD_IMPORTS
  ],
  templateUrl: './auth-base-layout.component.html',
  styleUrl: './auth-base-layout.component.scss',
  standalone: true,
})
export class AuthBaseLayoutComponent {

  @Input() title = "Titulo"

}
